export const isApplePaySupported = () =>
  typeof ApplePaySession !== 'undefined' && ApplePaySession.canMakePayments();
